
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center pt-20 pb-16 px-6"
      style={{
        backgroundImage: `url(https://public.readdy.ai/ai/img_res/eddb21cb1cb24efe124019cc111759d3.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-purple-900/80"></div>
      
      <div className="relative max-w-7xl mx-auto w-full">
        <div className="max-w-3xl">
          <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
            <i className="ri-shield-star-line text-blue-300"></i>
            <span className="text-white text-sm">Secure VPN Solution</span>
          </div>
          
          <h2 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Your Privacy,
            <br />
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
              Our Priority
            </span>
          </h2>
          
          <p className="text-xl text-blue-100 mb-8 leading-relaxed max-w-2xl">
            Experience ultimate online security with our advanced VPN technology. Browse anonymously, protect your data, and access content freely from anywhere in the world.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <button 
              onClick={scrollToContact}
              className="bg-white text-blue-600 px-8 py-4 rounded-lg font-semibold hover:shadow-2xl transition-all cursor-pointer whitespace-nowrap inline-flex items-center justify-center space-x-2"
            >
              <span>Get Started Now</span>
              <i className="ri-arrow-right-line"></i>
            </button>
            <button 
              onClick={() => {
                const element = document.getElementById('features');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-all cursor-pointer whitespace-nowrap inline-flex items-center justify-center space-x-2 border border-white/20"
            >
              <span>Learn More</span>
              <i className="ri-arrow-down-line"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
